import DOMPurify from 'isomorphic-dompurify'

const { sanitize } = DOMPurify

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('safe-html', (el, binding) => {
    el.innerHTML = sanitize(binding.value)
  })
})
